import { ILowesStormDoorEditingModel } from "../entities-generated/models/lowes-storm-door/lowes-storm-door-editing-model";
import { ILowesStormDoorListing } from "../entities-generated/models/lowes-storm-door/lowes-storm-door-listing";
import { IPublishLowesStormDoorRequest } from "../entities-generated/models/lowes-storm-door/publish-lowes-storm-door-request";
import { ApiClient } from "./admin-api-client";

class LowesStormDoorApiClientClass {
  public getImportedStormDoorList() {
    return ApiClient.get<ILowesStormDoorListing[]>('lowes-storm-door');
  }

  public getImportedStormDoor(doorId: string) {
    return ApiClient.get<ILowesStormDoorEditingModel>(`lowes-storm-door/${doorId}`);
  }

  public publishLowesStormDoor(request: IPublishLowesStormDoorRequest, doorId: string) {
    return ApiClient.post<void>(`lowes-storm-door/${doorId}`, request);
  }
}

export const LowesStormDoorApiClient = new LowesStormDoorApiClientClass();